<template>
  <main class="main-tag">
    <div class="login-page login-page-default row" id="login-page">
      <div class="col-md-4 offset-md-4 col-sm-8 offset-sm-2 text-left pt-5">
        <h4 class="welcome-heading-text q-mb-sm ptl">
          {{ t("login.wait_oidc_login") }}
        </h4>
      </div>
    </div>
  </main>
</template>

<script>
import { computed, onMounted } from "vue";
import store from "../store/index.js";
import { useRouter } from "vue-router";
import axios from "axios";
import axiosUrl from "../services/axios.service";
import { useI18n } from "vue-i18n";
import authService from "../services/auth.service.js";
import requestState from "../helpers/requestState.js";

const API_URL = axiosUrl.getAxiosUrl();

export default {
  name: "OidcAuth",
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    if (isLoggedIn.value == true) {
      router.push({
        name: "SearchGrants",
      });
    }
    const urlParams = new URLSearchParams(window.location.search);

    const newsletterId = computed({
      get: () => store.state.user.newsLetterId,
    });

    onMounted(async () => {
      await axios
        .post(API_URL + "/users/authenticate-oidc", {
          username: urlParams.get("username"),
          code: urlParams.get("code"),
          sid: urlParams.get("sid"),
        })
        .then(async () => {
          let returnUrl = router.currentRoute.value.query.returnUrl || "";

          requestState.isLogoutInProgress = false;
          requestState.isRefreshing = false;
          requestState.isRateLimitActive = false;
          requestState.refreshPromise = null;
          await authService.getAuthUserData(true, returnUrl).then(async () => {
            await authService.handleLoginRedirect();
          });
        })
        .catch(() => {
          router.replace({ path: "/geen-account" });
          return;
        });
    });

    return {
      t,
      router,
      isLoggedIn,
      newsletterId,
    };
  },
};
</script>
<style>
.ptl {
  padding-top: 100px;
}
</style>
